import angular from 'angular';
import * as R from 'ramda';
import controlDataService from '../data/control.data.service';
import ISharedModelService from './ISharedModel.service';

let _$filter;
let _controlDataService;

class controlSharedModelService extends ISharedModelService {
  constructor(
    $filter,
    controlDataService, // eslint-disable-line no-shadow
  ) {
    super('am');
    _$filter = $filter;
    _controlDataService = controlDataService;

    this.controlPreventiveEffectivenesses = null;

    this.controlDetectiveEffectivenesses = null;

    this.controlCorrectiveEffectivenesses = null;

    this.controlAdministrativeNatures = null;

    this.controlPhysicalNatures = null;

    this.controlTechnicalNatures = null;

    this.controlPrimaryControlTypes = null;

    this.controlCompensatingControlTypes = null;

    this.controlReviewSchedules = null;

    this.controlReviewTypes = null;

    this.controlResults = null;

    this.controlTypes = null;

    console.log('app.services.oversightSharedModelService created');
  }

  /** ********************************************************************************************
   *  ********************************************************************************************
   *  ********************************************************************************************
   * CRUD Operations
   *
   */

  /** ******************************************
   * Control Type
   */

  saveControlType(controlType) {
    // return _controlDataService.saveControlType(controlType).then(response => ({
    //   ...response.data,
    //   // NOTE: API returns model with these values false, so we fix them here
    // }));
    return _controlDataService.saveControlType(controlType).then((response) => {
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
      return Promise.reject(new Error('Error occurred while saving Control Type.'));
    });
  }


  /**
   *
   * @param collection - array of object with canView property
   * @param {Object} propertyObject - Object containing the property to search and the desired value
   * @returns {Array<Object>}
   */
  filterByProperty(collection, propertyObject) {
    return _$filter('filter')(collection, propertyObject);
  }

  transformToEffectivenessCssClass(controlType) {
    const classMappings = {
      1: 'status-tier-bar--neutral',
      2: 'status-tier-bar--caution',
      3: 'status-tier-bar--good',
      4: 'status-tier-bar--great',
    };
    // eslint-disable-next-line max-len
    controlType.controlPreventiveEffectivenessCssClass = classMappings[controlType.controlPreventiveEffectivenessId];
    controlType.controlPreventiveEffectivenessMeterLevel = controlType.controlPreventiveEffectivenessId - 1;
    controlType.controlDetectiveEffectivenessCssClass = classMappings[controlType.controlDetectiveEffectivenessId];
    controlType.controlDetectiveEffectivenessMeterLevel = controlType.controlDetectiveEffectivenessId - 1;
    // eslint-disable-next-line max-len
    controlType.controlCorrectiveEffectivenessCssClass = classMappings[controlType.controlCorrectiveEffectivenessId];
    controlType.controlCorrectiveEffectivenessMeterLevel = controlType.controlCorrectiveEffectivenessId - 1;
    return controlType;
  }

  transformControlTypeList(controls) {
    let controlTypeList = [];
    R.forEach(
      (item) => {
        const find = R.find(
          R.propEq('customerControlTypeId', item.customerControlType.customerControlTypeId),
          controlTypeList
        );
        if (!find) {
          const newType = angular.copy(item.customerControlType);
          newType.customerControls = [];
          newType.customerControls.push(item);
          controlTypeList.push(newType);
        } else {
          find.controls.push(item);
        }
      },
      controls
    );
    R.forEach(
      (item) => {
        item.customerControlCount = item.customerControls.length;
      },
      controlTypeList
    );

    controlTypeList = R.sortBy(R.prop('name'), controlTypeList);
    return controlTypeList;
  }

  transformControl(item) {
    item.controlAdministrativeNature = this.transformAdminNature(item, this.ControlAdministrativeNatures);
    item.controlPhysicalNature = this.transformPhysicalNature(item, this.ControlPhysicalNatures);
    item.controlTechnicalNature = this.transformTechnicalNature(item, this.ControlTechnicalNatures);
    // eslint-disable-next-line max-len
    item.controlCorrectiveEffectiveness = this.transformCorrectiveEffectiveness(item, this.ControlCorrectiveEffectivenesses);
    // eslint-disable-next-line max-len
    item.controlDetectiveEffectiveness = this.transformDetectiveEffectiveness(item, this.ControlDetectiveEffectivenesses);
    // eslint-disable-next-line max-len
    item.controlPreventiveEffectiveness = this.transformPreventiveEffectiveness(item, this.ControlPreventiveEffectivenesses);
    // eslint-disable-next-line max-len
    item.controlCompensatingControlType = this.transformCompensatingControlType(item, this.ControlCompensatingControlTypes);
    item.controlPrimaryControlType = this.transformPrimaryControlType(item, this.ControlPrimaryControlTypes);
  }

  transformAdminNature(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlAdministrativeNatureId', data.controlAdministrativeNatureId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformTechnicalNature(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlTechnicalNatureId', data.controlTechnicalNatureId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformPhysicalNature(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlPhysicalNatureId', data.controlPhysicalNatureId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformCorrectiveEffectiveness(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlCorrectiveEffectivenessId', data.controlCorrectiveEffectivenessId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformDetectiveEffectiveness(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlDetectiveEffectivenessId', data.controlDetectiveEffectivenessId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformPreventiveEffectiveness(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlPreventiveEffectivenessId', data.controlPreventiveEffectivenessId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformCompensatingControlType(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlCompensatingControlTypeId', data.controlCompensatingControlTypeId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }

  transformPrimaryControlType(data, propertyList) {
    let result = {};
    const find = R.find(
      R.propEq('controlPrimaryControlTypeId', data.controlPrimaryControlTypeId),
      propertyList
    );
    if (!find) {
      result = null;
    } else {
      result = find;
    }
    return result;
  }


  initControlAdmin() {
    return _controlDataService.initControlAdmin().then((getControlInitResponse) => {
      if (getControlInitResponse.data.ControlResults) {
        this.ControlResults = getControlInitResponse.data.ControlResults.result;
      }

      if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
        this.ControlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
      }

      if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
        this.ControlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
      }

      if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
        this.ControlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
      }

      if (getControlInitResponse.data.ControlAdministrativeNatures) {
        this.ControlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
      }

      if (getControlInitResponse.data.ControlPhysicalNatures) {
        this.ControlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
      }

      if (getControlInitResponse.data.ControlTechnicalNatures) {
        this.ControlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
      }

      if (getControlInitResponse.data.ControlPrimaryControlTypes) {
        this.ControlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
      }

      if (getControlInitResponse.data.ControlCompensatingControlTypes) {
        this.ControlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
      }

      if (getControlInitResponse.data.ControlReviewSchedules) {
        this.ControlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
      }

      if (getControlInitResponse.data.ControlReviewTypes) {
        this.ControlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
      }

      if (getControlInitResponse.data.ControlTypes) {
        this.ControlTypes = getControlInitResponse.data.ControlTypes.result;
      }
    });
  }
}

controlSharedModelService.$inject = [
  '$filter',
  'controlDataService',
];

export default angular.module('app.services.controlSharedModelService', [
  controlDataService,
])
  .service('controlSharedModelService', controlSharedModelService)
  .name;
